module.exports = __webpack_public_path__ + "img/racetrack-scottsville-turf-inner.642ee8e4.svg";